<template>
	<div class="notification-bar" :class="notificationTypeClass">
		<p>{{ notification.message }}</p>
	</div>
</template>

<script>
export default {
	data() {
		return {
			timeout: null,
			text: 'Congratulations'
		}
	},
	mounted() {
		this.timeout = setTimeout(() => {
			this.$store.dispatch('notification/remove', this.notification)
		}, 5000)
	},
	beforeDestroy() {
		clearTimeout(this.timeout)
	},
	props: {
		notification: {
			type: Object,
			required: true
		}
	},
	computed: {
		notificationTypeClass() {
			return `notification-bar-${this.notification.type}`
		}
	}
}
</script>

<style lang="scss" scoped>
@import '../styles/components/notificationBar.scss';
</style>
